import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import { setUser } from '../user';
import history from '../../config/history';
import mixpanelConstants from '../../constants/mixpanel';

export const setStep1NextPage = createAction('SET_STEP1_NEXT_PAGE');
export const setStep1Errors = createAction('SET_STEP1_ERRORS');
export const setStep1Display = createAction('SET_STEP1_DISPLAY');
export const setStep1Message = createAction('SET_STEP1_MESSAGE');
export const setStep1FirstName = createAction('SET_STEP1_FIRST_NAME');
export const setStep1LastName = createAction('SET_STEP1_LAST_NAME');
export const setStep1Addres = createAction('SET_STEP1_ADDRESS');
export const setStep1City = createAction('SET_STEP1_CITY');
export const setStep1State = createAction('SET_STEP1_STATE');
export const setStep1Zipcode = createAction('SET_STEP1_ZIPCODE');
export const setStep1PrimaryPhone = createAction('SET_STEP1_PRIMARY_PHONE');
export const setStep1AlternatePhone = createAction('SET_STEP1_ALTERNATE_PHONE');
export const resetStep1 = createAction('RESET_STEP1');
export const setAddress2 = createAction('SET_ADDRESS2');

const initialState = {
	address: '',
	address2: '',
	alternatePhoneNumber: '',
	city: '',
	display: 'none',
	errors: {},
	firstName: '',
	lastName: '',
	message: '',
	nextPage: '/nurse/onboarding/preferences',
	primaryPhoneNumber: '',
	state: '',
	zipcode: ''
};

export default handleActions(
	{
		RESET_STEP1: () => initialState,
		SET_ADDRESS2: (state, action) => ({
			...state,
			address2: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_STEP1_ADDRESS: (state, action) => ({
			...state,
			address: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_STEP1_ALTERNATE_PHONE: (state, action) => ({ ...state, alternatePhoneNumber: action.payload }),
		SET_STEP1_CITY: (state, action) => ({
			...state,
			city: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_STEP1_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SET_STEP1_ERRORS: (state, action) => ({ ...state, errors: action.payload }),
		SET_STEP1_FIRST_NAME: (state, action) => ({
			...state,
			firstName: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_STEP1_LAST_NAME: (state, action) => ({
			...state,
			lastName: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_STEP1_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_STEP1_NEXT_PAGE: (state, action) => ({ ...state, nextPage: action.payload }),
		SET_STEP1_PRIMARY_PHONE: (state, action) => ({ ...state, primaryPhoneNumber: action.payload }),
		SET_STEP1_STATE: (state, action) => ({ ...state, state: action.payload }),
		SET_STEP1_ZIPCODE: (state, action) => ({ ...state, zipcode: action.payload })
	},
	initialState
);

export const updateUserContact = () => {
	return function (dispatch, getState) {
		const { firstName, lastName, address, city, state, zipcode, primaryPhoneNumber, alternatePhoneNumber, address2 } =
			getState().step1;

		dispatch(setStep1Display('block'));
		Agent.updateUserContact(
			firstName,
			lastName,
			address,
			city,
			state,
			zipcode,
			primaryPhoneNumber,
			alternatePhoneNumber,
			address2
		).then((response) => {
			if (response.ok) {
				dispatch(setStep1Message(''));
				dispatch(setStep1Display('none'));

				trackContactUpdate(getState());
				history.push('/nurse/onboarding/preferences');
			} else {
				dispatch(setStep1Message(response.data));
				dispatch(setStep1Display('none'));
			}
		});
	};
};

export const fetchUserContact = () => {
	return function (dispatch, getState) {
		Agent.userContact().then((response) => {
			if (response.ok) {
				dispatch(setUser(response.data));

				dispatch(
					setStep1FirstName(
						response.data.first_name !== null ? response.data.first_name : getState().signup.qs.firstname
					)
				);
				dispatch(
					setStep1LastName(response.data.last_name !== null ? response.data.last_name : getState().signup.qs.firstname)
				);
				dispatch(setStep1Addres(response.data.address !== null ? response.data.address : ''));
				dispatch(setAddress2(response.data.additional_address !== null ? response.data.additional_address : ''));
				dispatch(setStep1City(response.data.city !== null ? response.data.city : ''));
				dispatch(setStep1State(response.data.state !== null && response.data.state != '' ? response.data.state : ''));
				dispatch(setStep1Zipcode(response.data.zip !== null ? response.data.zip : getState().signup.qs.zipcode));
				dispatch(setStep1PrimaryPhone(response.data.phone !== null ? response.data.phone : ''));
				dispatch(setStep1AlternatePhone(response.data.alt_phone !== null ? response.data.alt_phone : ''));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

function trackContactUpdate(appState) {
	const { firstName, lastName, city, state, zipcode, primaryPhoneNumber, alternatePhoneNumber } = appState.step1;
	let userId = appState.user.id;

	mixpanel.identify(userId);

	mixpanel.people.set({
		$city: city ? city : null,
		$country_code: city ? 'US' : null,
		$first_name: firstName,
		$last_name: lastName,
		$phone: primaryPhoneNumber,
		$region: state,
		alternate_phone_number: alternatePhoneNumber,
		zipcode: zipcode
	});

	mixpanel.track(mixpanelConstants.CONTACT_INFO_SAVE);
}
